import AspectsMenuController from './aspectsMenuController';


const AspectsMenuComponent = {
    template: require('./aspectsMenuView.html'),
    controller: AspectsMenuController
};

export default AspectsMenuComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/aspectsMenu/aspectsMenuComponent.js